<template>
  <div
    :style="{
      padding: '24px',
      margin: '24px 16px 24px 16px',
      background: '#fff',
      minHeight: '100px',
    }"
  >
    <a-form-model
      layout=""
      :model="formInline"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      labelAlign="left"
      @submit="handleSubmit"
      @submit.native.prevent
    >
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="用户id">
            <a-input v-model="details.userUid" placeholder=""></a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="11">
          <a-form-model-item label="用户名称">
            <a-input v-model="details.userName" placeholder=""></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="用户电话">
            <a-input v-model="details.userPhone" placeholder="">
            </a-input>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="反馈">
            <a-textarea
              v-model="details.feedbackContent"
              placeholder="我是反馈内容"
              :auto-size="{ minRows: 3, maxRows: 5 }"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="11" :offset="2"> </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="反馈图片">
            <img :src="details.userHeadImg" alt="" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="回复内容">
            <a-textarea
              v-model="content"
              placeholder="已处理"
              :auto-size="{ minRows: 3, maxRows: 5 }"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <a-table :columns="columns" :data-source="data" v-if="show"> </a-table>
    <a-button @click="deal">处理</a-button>
    <a-button @click="goBack">返回</a-button>
  </div>
</template>

<script>
import { userListDetails, userListDeal } from "@/api/storeApi.js";
import { message } from "ant-design-vue";
const columns = [
  {
    title: "Age",

    dataIndex: "name",
    key: "name",
    slots: { title: "customTitle" },
    scopedSlots: { customRender: "name" },
  },
  {
    title: "Age",
    dataIndex: "age",
    key: "age",
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "address",
  },
  {
    title: "Tags",
    key: "tags",
    dataIndex: "tags",
    scopedSlots: { customRender: "tags" },
  },
  {
    title: "Action",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];

const data = [
  {
    key: "1",
    name: "John Brown",
    age: 32,
    address: "New York No. 1 Lake Park",
    tags: ["nice", "developer"],
  },
];
// import chooseAnItem from "./chooseAnItem.vue";
export default {
  components: {
    // chooseAnItem,
  },
  data() {
    return {
      details: {
        feedbackContent: "",
        userPhone: "",
        record: "",
        userHeadImg: "",
      },
      content: "",
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      formInline: {
        user: "",
        password: "",
      },
      data,
      columns,
      show: false,
    };
  },
  mounted() {
    this.getUserListDetails();
  },
  methods: {
    onChange(date, dateString) {
      console.log(date, dateString);
    },
    getUserListDetails() {
      let objId = this.$route.query.objId;
      userListDetails(objId).then((res) => {
        this.details = res.data;
        console.log(res);
      });
    },
    deal() {
      let objId = this.$route.query.objId;
      if (this.content.trim() === "") {
        message.warning("回复内容不能为空");
      } else {
        userListDeal(objId, this.content).then((res) => {
          message.success(res.info);
          this.$router.push("/home/feedback/feedbackHome");
        });
      }
    },
    goBack() {
      this.$router.push("/home/feedback/feedbackHome");
    },
    showtable(show) {
      this.show = show;
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/systemManagement/feedback/feedbackDetails/feedbackDetails.vue